import styled from 'styled-components'

export default styled.section`
  align-items: center;
  background: #FFFFFF;
  display: flex;
  padding: 3em 0;
`



// WEBPACK FOOTER //
// ./src/components/OurServices.js